import { Table, TableBody, TableFooter, TableHead, TableRow } from '../../../UIKit';
import CheckBoxCell from '../Components/CheckBoxCell';
import Cell from '../Components/DefaultCell';
import ProfileImageCell from '../Components/ProfileImageCell';
import TimeRangeCell from '../Components/TimeRangeCell';
import { CellTypes, TableComponents } from '../DataTable.types';
import CustomerCell from '../Components/CustomerCell';
import PresenceStatusCellContainer from '../Components/PresenceStatusCell.container';

export const tableDefaultComponents = () => ({
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableFooter,
  TableHeadCell: Cell,
  TableCells: {
    default: Cell,
  },
});

// Merged the default Mat-UI Components with custom overwritten components
export const mergeComponents = (customComponents: TableComponents | undefined) => {
  const { TableCells, ...defaults } = tableDefaultComponents();
  if (!customComponents) return { ...defaults, TableCells };

  const cells = {
    ...TableCells,
    ...customComponents.TableCells,
  };

  return {
    ...defaults,
    ...customComponents,
    TableCells: cells,
  };
};

// Fetches the correct cell for the property of that column
// Can be extended to fit more shit as we need it
export const getTableCellForProp = (type: CellTypes) => {
  switch (type) {
    case CellTypes.Image:
      return ProfileImageCell;
    case CellTypes.Checkbox:
      return CheckBoxCell;
    case CellTypes.TimeRange:
      return TimeRangeCell;
    case CellTypes.Customer:
      return CustomerCell;
    case CellTypes.Presence:
      return PresenceStatusCellContainer;
    case CellTypes.Currency:
    case CellTypes.Email:
    case CellTypes.Input:
    case CellTypes.Number:
    case CellTypes.Select:
    case CellTypes.String:
    default:
      return Cell;
  }
};

// Default formatting function if formatter is undefined
export const defaultFormatter = (value: any) => value;
